export default __webpack_public_path__ + "static/media/copy-icon.672974a2.svg";